<template>
  <div class="box">
    <h1 class="title is-4 has-text-primary">
      Auto Facturas
    </h1>
    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Folio</th>
          <th>Fecha</th>
          <th>Total</th>
          <th>Tipo</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr v-if="isLoading">
          <td
            colspan="8"
            class="is-loading"
          >
            <a class="button is-loading is-fullwidth">
              Cargando..
            </a>
          </td>
        </tr>
        <template v-else>
          <tr
            v-if="invoices.length === 0"
          >
            <td
              class="empty"
              colspan="7"
            >
              Sin datos
            </td>
          </tr>
          <tr
            v-for="(invoice, index) in invoices"
            :key="index"
          >
            <td>
              {{ invoice.voucherSeries }}
              -
              {{ invoice.voucherConsecutive }}
            </td>
            <td>{{ invoice.voucherDate | toHumanDate }}</td>
            <td>{{ invoice.voucherTotal | toCurrency(invoice.voucherCurrency) }}</td>
            <td>{{ voucherTypeLabel(invoice.voucherType) }}</td>
            <td>
              <div class="buttons">
                <RouterLink
                  class="button is-info"
                  :to="{ name: 'InvoiceDetail', params: { uuid: invoice.id } }"
                >
                  <BIcon icon="pencil" />
                </RouterLink>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import { voucherType as voucherTypeCatalog } from '@machete/common-catalogs';

import AppPagination from '../../../../components/AppPagination.vue';

export default {
  name: 'AutoInvoiceList',
  components: { AppPagination },
  data() {
    return {
      isLoading: false,
      buttonsMax: 5,
    };
  },
  computed: {
    ...mapState({
      total: state => state.invoices.total,
      totalPages: state => state.invoices.totalPages,
    }),
    ...mapGetters({
      invoices: 'invoices/cleanInvoices',
    }),
    voucherTypeLabel() {
      return (key) => {
        const voucherType = voucherTypeCatalog.find(type => type.key === key);

        return voucherType.value;
      };
    },
    lastPage() {
      return Math.ceil(this.invoices.length / this.itemsPerPage);
    },
    currentPage() {
      return parseInt(this.$route.query.page, 10);
    },
    size() {
      return this.$route.query.size;
    },
  },
  watch: {
    buttonsMax(newValue, oldValue) {
      if (newValue % 2) {
        return;
      }
      if (newValue < oldValue) {
        this.buttonsMax = newValue - 1;
      }
      if (newValue > oldValue) {
        this.buttonsMax = newValue + 1;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.page) next();
    else {
      next({ name: to.name, query: { page: 1, size: 20 } });
    }
  },
  async beforeRouteUpdate(to, from, next) {
    const { page = 1, size = 20 } = to.query;

    await this.getAll({
      filter: 'auto',
      page,
      size,
    });

    next({ query: { page, size } });
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getAll({
      filter: 'auto',
      page: this.currentPage,
      size: this.size,
    });
    this.isLoading = false;
  },
  methods: {
    ...mapActions({
      getAll: 'invoices/getAll',
    }),
    goToPage(page) {
      const { size = 20 } = this.$route.query;

      const query = {
        page,
        size,
      };

      this.$router.push({ query });
    },
    checkLastPage() {
      if (this.currentPage < this.lastPage) {
        this.$router.push({ query: { page: this.lastPage } });
      }
    },
  },
};
</script>

<style scoped>
.empty {
  vertical-align: center;
  text-align: center;
}
</style>
